import BaseService from '../BaseService'
import axios from "axios";

class KeywordService extends BaseService {
    constructor() {
        super('/keyword');
    }

    generateTitle ({ payload }) {
        return axios.post(`${this.resource}/generate-title`, payload)
    }

}

export default new KeywordService()
